// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useEffect, FocusEvent, useRef} from 'react';
import cn from 'classnames';
import '../css/core/input.less';

interface IProps {
    min_height?: number;
    on_change: (value: string)=>void;
    on_blur?: (e: FocusEvent<HTMLTextAreaElement>)=>void;
    on_focus?: (e: FocusEvent<HTMLTextAreaElement>)=>void;
    on_key_down?: (e: React.KeyboardEvent<HTMLTextAreaElement>)=>void;
    value: string;
    name?: string;
    cls?: string;
    placeholder: string;
    auto_height?: boolean;
    as_html?: boolean;
}
const Textarea = React.forwardRef<HTMLTextAreaElement, IProps>((props, ref)=>{
    const {auto_height = true} = props;
    const text_area_ref = useRef(undefined);
    const change_height = el=>{
        if (!auto_height)
            return;
        el.style.height = '0px';
        const scroll_h = el.scrollHeight;
        const min_h = props.min_height || 44;
        el.style.height = el.value && scroll_h > min_h ? el.scrollHeight+'px'
            : `${min_h}px`;
    };
    const on_change_plus_h = ev=>{
        ev.persist();
        change_height(ev.target);
        props.on_change(ev.target.value);
    };
    useEffect(()=>{
        // XXX dmitriiz:: solve forwarded ref type
        // @ts-ignore
        if (ref?.current)
        {
            // @ts-ignore
            change_height(ref.current);
        }
        if (text_area_ref?.current)
        {
            setTimeout(()=>{
                // @ts-ignore
                change_height(text_area_ref.current);
            }, 1000);
        }
        // @ts-ignore
    }, [ref?.current]);
    return <textarea value={props.value} name={props.name}
      ref={ref||text_area_ref}
      onChange={on_change_plus_h} className={cn('hola_input', props.cls)}
      placeholder={props.placeholder} onFocus={props.on_focus}
      onBlur={props.on_blur} onKeyDown={props.on_key_down} />;
});

export {Textarea};
